// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__vpVhQ","checkmark":"Checkbox_checkmark__dGI6e","p":"Checkbox_p__6bj9Z","rotate":"Checkbox_rotate__pZmrZ"};